import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { UsgService } from 'src/app/usg.service';
import { PathologyService } from 'src/app/pathology.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoginService } from 'src/app/login.service';

@Component({
    selector: 'app-pathologies',
    templateUrl: './pathologies.component.html',
    styleUrls: ['./pathologies.component.scss'],
    standalone: false
})
export class PathologiesComponent implements OnInit, OnDestroy {
  /** Returns true if path.CreationTime is less than 2 hours ago */
  isLessThan2Hours(path: any): boolean {
    if (!path.CreationTime) return false;
    const creation = new Date(path.CreationTime).getTime();
    const now = Date.now();
    return (now - creation) < 2 * 60 * 60 * 1000;
  }
  sub = new Subscription();
  pathSub: Subscription = new Subscription();
  scanning = false;
  @ViewChild('barcodeInput') barcodeInput!: ElementRef<HTMLInputElement>;
  @ViewChild('barcodeInputP') barcodeInputP!: ElementRef<HTMLInputElement>;
  reportToShow: number;
  labcomment: string[] = [];
  labReports: any[] = [];
  otherInboxItems: any[] = [];
  unassignedInboxItems: any[] = [];
  inbox = false;
  missingLabReports: boolean = false;
  searchFromDate: Date;
  searchToDate: Date;
  allReportsReceived: boolean = false;
  pathologyScanning: number;
  barcodeInputPathology: string;

  private commentChange$ = new Subject<{ index: number, labresultid: number, comment: string }>();

  constructor(public pathologyS:PathologyService, public es:ExamsService, public gs:UsgService, public atS:AutotextService, public loginService: LoginService) { }

  ngOnInit() {
    this.pathologyS.getPathologies();
    if(this.es.isClosed){
      this.pathologyS.pathologyForm.disable({emitEvent:false})
    }
    //go a day back from es.CreationTime - Ignore the time component
    this.searchFromDate = new Date(this.es.CreationTime);
    this.searchFromDate.setDate(this.searchFromDate.getDate() - 1);
    this.searchFromDate.setHours(0, 0, 0, 0);
    //for to date, set to es.CreationTime + 7 days
    this.searchToDate = new Date(this.es.CreationTime);
    this.searchToDate.setDate(this.searchToDate.getDate() + 7);
    this.searchToDate.setHours(23, 59, 59, 999);
    this.sub = this.es.examLoaded$.subscribe(() => {
      this.pathologyS.getPathologies();
      if(this.es.isClosed){
        this.pathologyS.pathologyForm.disable({emitEvent:false})
      }
    });
    // Listen for barcode changes
    this.pathologyS.pathologyForm.get('BarCode')?.valueChanges.subscribe(val => {
      if (this.scanning && val) {
        setTimeout(() => {
          this.scanning = false;
        }, 1000);
      }
    });

    this.pathSub = this.pathologyS.loaded.subscribe(() => {
      
    });

    // Subscribe to comment changes with debounce and distinctUntilChanged
    this.sub.add(
      this.commentChange$
        .pipe(
          debounceTime(500),
          distinctUntilChanged((a, b) => a.comment === b.comment && a.labresultid === b.labresultid)
        )
        .subscribe(({ index, labresultid, comment }) => {
          this.pathologyS.saveComment(comment, labresultid);
        })
    );
    this.loadLabReports();
    this.allReportsReceived = this.es.examObject.LabReceived;
  }

  loadLabReports() {
    this.pathologyS.getLabReports().subscribe((data:any[]) => {
      this.labReports = [];
      this.otherInboxItems = [];
      for(let item of data){
        //if date string yyyy-mm-dd of item.SampleDate is the same date as exam creation date, add to inboxItems
        const sampleDate = new Date(item.SampleDate);
        const examDate = new Date(this.es.CreationTime);
        //if (sampleDate.toDateString() === examDate.toDateString()) {
        if(item.ExamID == this.es.examID) {
          this.labReports.push(item);
        }
        else {
          this.otherInboxItems.push(item);
        }
      }
      let i=0;
      for(let p of this.labReports){
        this.labcomment[i] = p.DoctorNote ? p.DoctorNote : '';
        i++;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.pathSub.unsubscribe();
  }

  startScan() {
    this.scanning = true;
    this.pathologyS.pathologyForm.get('BarCode').setValue('');
    setTimeout(() => {
      this.barcodeInput?.nativeElement.focus();
    });
  }

  scanExistingPathology(pathid: number) {
    this.pathologyScanning = pathid;
    this.scanning = true;
    setTimeout(() => {
      this.barcodeInputP?.nativeElement.focus();
    });
  }

  barcodeScanTimeout: any;

  onBarcodeInputChange() {
    if (this.barcodeScanTimeout) {
      clearTimeout(this.barcodeScanTimeout);
    }
    this.barcodeScanTimeout = setTimeout(() => {
      this.finishScan();
    }, 1000);
  }

  finishScan() {
    this.scanning = false;
      this.pathologyS.updateBarcode(this.pathologyScanning, this.barcodeInputPathology).subscribe(() => {
        this.pathologyScanning = null;
        this.barcodeInputPathology = '';
        this.pathologyS.getPathologies();
      });
  }

  showReport(reportId: number, inbox = false) {
    this.reportToShow = null;
    setTimeout(() => {
      this.inbox = inbox;
      this.reportToShow = reportId;
    });
  }

  saveComment(index: number, labresultid: number) {
    const comment = this.labcomment[index];
    // Emit the comment change to the Subject
    this.commentChange$.next({ index, labresultid, comment });
  }

  markAsReviewed(autoIndex: number) {
    this.pathologyS.markAsReviewed(autoIndex).subscribe((data) => {
      //this.pathologyS.getPathologies();
      this.loadLabReports();
      //generate exam printout if exam is signed
      if(this.es.isClosed)
        this.es.printExam();
    });
  }

  reportClosed(updated: boolean) {
    if (updated) {
      this.loadLabReports();
    }
    this.reportToShow = null;
  }

  searchMissingReports() {
    this.unassignedInboxItems = [];
    this.pathologyS.searchMissingLabReports(this.searchFromDate, this.searchToDate).subscribe((data: any[]) => {
      this.unassignedInboxItems = data;
    });
  }

  notFromToday() {
    //if this.es.CreationTime is more than a day old return true
    const creationTime = new Date(this.es.CreationTime);
    const today = new Date();
    const diffTime = today.getTime() - creationTime.getTime();
    const diffDays = diffTime / (1000 * 3600 * 24);
    return diffDays >= 1;
  }

  allLabResultsReceived(){
    this.es.allLabResultsReceived(this.allReportsReceived).subscribe(() => {
      
    }, error => {
      console.log(error);
    });
  }

}
